module.exports = __webpack_public_path__ + "static/Logo20ScoopsVC-e7eec3bd5d22659a93207aa28f45eb51.svg";